import { render, staticRenderFns } from "./ComponentLargeVolumeUSD.vue?vue&type=template&id=fc433bae"
import script from "./ComponentLargeVolumeUSD.vue?vue&type=script&lang=js"
export * from "./ComponentLargeVolumeUSD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports